export const SUPPORTED_IMAGE_MIMETYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/heic', // iphone type which is harder to support
  'image/svg+xml',
];

export const getFiles = (fileList: FileList) => {
  const files: File[] = [];
  new Array(fileList.length).fill(0).forEach(i => {
    const item = fileList.item(i);
    if (item) {
      files.push(item);
    }
  });
  return files;
};
